<template>
  <div>
    <ForbiddenKeywordsHead
            :countFilterParams="countFilterParams"
            :showFilter="showFilter"
            @toggleFilter="toggleFilter"
            @filter="$emit('filter')"
            @reload="$emit('reload')"
    />

    <div class="table-filter-wrap">
      <ForbiddenKeywordsFilter
              :showFilter="showFilter"
              :filterGetParams="filterGetParams"
              @close="closeFilter"
              @changeFilter="data => $emit('changeFilter', data)"
              @resetFilter="$emit('resetFilter')"
      />

      <ForbiddenKeywordsTable
          :countFilterParams="countFilterParams"
              @showMore="$emit('showMore')"
              @resetFilter="$emit('resetFilter')"
              @updateTable="$emit('updateTable')"
              @reload="$emit('reload')"
      />
    </div>
  </div>
</template>

<script>


  import ForbiddenKeywordsHead from "./ForbiddenKeywordsHead/ForbiddenKeywordsHead";
  import ForbiddenKeywordsFilter from "./ForbiddenKeywordsFilter/ForbiddenKeywordsFilter";
  import ForbiddenKeywordsTable from "./ForbiddenKeywordsTable/ForbiddenKeywordsTable";

  export default {
    name: "ForbiddenKeywordsTableAdmin",

    components: {
      ForbiddenKeywordsHead,
      ForbiddenKeywordsFilter,
      ForbiddenKeywordsTable,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
    },

    data(){
      return{
        showFilter: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },
    }
  }
</script>

<style scoped>

</style>
